module.exports = __webpack_public_path__ + "img/lasrozas.1d6900e3.jpg";